<template>
  <el-select
    :class="classNames"
    :disabled="disabled"
    :loading="isLoadingRef"
    :multiple="multiple"
    :placeholder="$t('placeholder.select')"
    :remote-method="updateBrandListByKeyword"
    :value="value"
    remote
    filterable
    @change="handleUpdateSelectedBrands"
  >
    <el-option
      v-for="item in brandsRef"
      :key="item[valueKey]"
      :label="item.name"
      :value="item[valueKey]"
    />
  </el-select>
</template>

<script>
import { createComponent, ref, computed, onMounted } from '@vue/composition-api'
import VaderService from '../../api/vader'

const BrandSelector = createComponent({
  props: {
    value: {
      type: [Array, String],
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    valueKey: {
      type: String,
      default: 'slug',
    },
  },
  setup(props, { emit }) {
    const isLoadingRef = ref(false)
    const classNames = computed(() => ({
      'w-100': props.fullWidth,
    }))

    const brandsRef = ref([])
    const updateBrandListByKeyword = async (query) => {
      if (query !== '') {
        isLoadingRef.value = true;
        try {
          const data = await VaderService.getBrands(query)
          brandsRef.value = data.data.data
        } finally {
          isLoadingRef.value = false
        }
      } else {
        brandsRef.value = [];
      }
    }
    const handleUpdateSelectedBrands = (values) => {
      emit('input', values)
    }

    onMounted(() => {
      if (props.multiple) {
        handleUpdateSelectedBrands([])
      }
    })

    return {
      isLoadingRef,
      classNames,

      brandsRef,

      updateBrandListByKeyword,
      handleUpdateSelectedBrands,
    }
  },
})

export default BrandSelector
</script>
